
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, subtitle }) => {
  const { colors } = useTheme();
  
  return (
    <div className="text-center mb-12">
      <h2 className="text-4xl md:text-5xl font-bold mb-4 relative inline-block" style={{ color: colors.text.primary }}>
        {title}
        <span 
          className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2/3 h-1 rounded-full"
          style={{
            background: `linear-gradient(90deg, ${colors.primary.main} 0%, ${colors.accent.mint} 100%)`
          }}
        ></span>
      </h2>
      {subtitle && (
        <p className="text-lg max-w-2xl mx-auto" style={{ color: colors.text.secondary }}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
    